import React from 'react';
import PropTypes from 'prop-types';
import { ContentPackageGridTemplate } from './shared/ContentPackageGridTemplate';

export const ContentPackageTemplate6a = ({ data, content, isAboveTheFold }) => {
  return (
    <ContentPackageGridTemplate
      gridConfig={{
        lead: true,
        medium: [1, 2],
        small: [3, 4, 5],
        bottom: 'content_package_bottom'
      }}
      data={data}
      content={content}
      isAboveTheFold={isAboveTheFold}
    />
  );
};

ContentPackageTemplate6a.defaultProps = {
  isAboveTheFold: false
};

ContentPackageTemplate6a.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
